// Единый источник правды для навигации: состав групп, порядок, иконки и заголовки страниц.
// Раньше пункты меню были продублированы четыре раза (десктоп/мобилка × список/фолбэк) —
// теперь список один, а Root.js только рисует его.

// Иконки — inline SVG на currentColor, поэтому красятся темой и активным состоянием.
// (Прежние .svg-фоны через background-image перекрасить было нельзя.)
const P = {
    chat: 'M21 11.5a8.4 8.4 0 0 1-9 8.4 9.3 9.3 0 0 1-2.8-.4L3 21l1.6-4.6A8.2 8.2 0 0 1 3 11.5a8.4 8.4 0 0 1 9-8.4 8.4 8.4 0 0 1 9 8.4z',
    campaigns: 'M3 11l18-7-7 18-2.5-8L3 11z',
    templates: 'M4 5a2 2 0 0 1 2-2h8l6 6v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zM14 3v6h6',
    messages: 'M4 5h16v11H8l-4 4zM8 9h8M8 12.5h5',
    analytics: 'M4 20V10M10 20V4M16 20v-7M22 20H2',
    reports: 'M5 3h14v18H5zM9 8h6M9 12h6M9 16h3',
    partners: 'M16 20v-1.6a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4V20M22 20v-1.6a4 4 0 0 0-3-3.8M16.5 3.7a4 4 0 0 1 0 6.6',
    users: 'M4 21a8 8 0 0 1 16 0',
    balance: 'M3 8h18v11H3zM3 8l3.5-4h11L21 8M12 12.5v2.5',
    me: 'M4 21a8 8 0 0 1 16 0',
};

// У «Партнёров» и «Пользователей» кроме пути есть кружок-голова — рисуем отдельно.
const CIRCLES = {
    partners: { cx: 9, cy: 7, r: 3.4 },
    users: { cx: 12, cy: 8, r: 4 },
    me: { cx: 12, cy: 8, r: 4 },
};

export function NavIcon({ name, size = 17 }) {
    const d = P[name];
    if (!d) return null;
    const c = CIRCLES[name];
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.9"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
        >
            {c && <circle cx={c.cx} cy={c.cy} r={c.r} />}
            <path d={d} />
        </svg>
    );
}

// Группы отражают то, что оператор делает: ведёт переписку → разбирает результат → администрирует.
export const NAV_GROUPS = [
    { label: 'Работа', keys: ['chat', 'campaigns', 'templates'] },
    { label: 'Статистика', keys: ['messages', 'analytics', 'reports'] },
    { label: 'Управление', keys: ['partners', 'users', 'balance'] },
];

// Разделы, которые показываем всегда, даже если сервер не прислал их в me.tabs
// (поведение унаследовано от прежнего Root.js — менять его здесь не стали).
export const ALWAYS_VISIBLE = ['templates', 'campaigns', 'reports', 'analytics', 'chat'];

// Под-вкладки живут внутри «Партнёров», поэтому в рельсе их не показываем.
export const HIDDEN_KEYS = ['tariffs', 'partner-tariffs'];

export const TITLES = {
    chat: 'Чат',
    campaigns: 'Рассылки',
    templates: 'Шаблоны',
    messages: 'Сообщения',
    analytics: 'Аналитика',
    reports: 'Отчёты',
    partners: 'Партнёры',
    users: 'Пользователи',
    balance: 'Баланс',
    me: 'Личный кабинет',
};

// Подзаголовок в шапке страницы — короткий контекст, а не описание.
export const SUBTITLES = {
    messages: 'Журнал доставки',
    analytics: 'Сводка по сообщениям и расходу',
    reports: 'Выгрузки в Excel',
    users: 'Доступы и роли',
    me: 'Ваш профиль',
};

// Собирает плоский список видимых разделов, разложенный по группам.
// tabs — то, что прислал сервер в me.tabs; всё, чего нет в группах, уходит в «Ещё»,
// чтобы новый раздел с бэкенда не пропал из меню молча.
export function buildNav(tabs) {
    const list = (tabs || []).filter((t) => !HIDDEN_KEYS.includes(t.key));
    const titleByKey = {};
    list.forEach((t) => { titleByKey[t.key] = t.title; });

    const available = new Set([...list.map((t) => t.key), ...ALWAYS_VISIBLE]);
    const placed = new Set();

    const groups = NAV_GROUPS.map((g) => ({
        label: g.label,
        items: g.keys
            .filter((k) => available.has(k))
            .map((k) => {
                placed.add(k);
                return { key: k, title: titleByKey[k] || TITLES[k] || k };
            }),
    })).filter((g) => g.items.length > 0);

    const rest = [...available].filter((k) => !placed.has(k));
    if (rest.length > 0) {
        groups.push({
            label: 'Ещё',
            items: rest.map((k) => ({ key: k, title: titleByKey[k] || TITLES[k] || k })),
        });
    }

    return groups;
}
